import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getAddressSchema } from "@faire/web--source/ui/Addresses/addressSchema";
import { useMutation as useValidatePhoneNumber } from "@faire/web-api--source/api/v2/addresses/validate-phone-number/post-hooks";
import { IValidatePhoneNumberRequest } from "@faire/web-api--source/indigofair/data/IValidatePhoneNumberRequest";
export var useFormValidation = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useValidatePhoneNumber = useValidatePhoneNumber(), validatePhoneNumber = _useValidatePhoneNumber.mutateAsync;
    var validateForm = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var errors, addressSchema, is_valid;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        errors = {};
                        addressSchema = getAddressSchema(values.country, strictLocalize);
                        if (values.firstName.length < 1) {
                            errors.firstName = strictLocalize({
                                id: "/kt5um",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "First name is required"
                                    }
                                ]
                            });
                        }
                        if (values.lastName.length < 1) {
                            errors.lastName = strictLocalize({
                                id: "/DMeVq",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Last name is required"
                                    }
                                ]
                            });
                        }
                        if (values.storeName.length < 1) {
                            errors.storeName = strictLocalize({
                                id: "A0holT",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Store name is required"
                                    }
                                ]
                            });
                        }
                        if (values.address1.length < 1) {
                            errors.address1 = strictLocalize({
                                id: "rnalI7",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Street address is required"
                                    }
                                ]
                            });
                        }
                        if (values.city.length < 1) {
                            errors.city = strictLocalize({
                                id: "SqMlgn",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "City is required"
                                    }
                                ]
                            });
                        }
                        if (values.state.length < 1 && addressSchema.required_fields.includes("state")) {
                            errors.state = strictLocalize({
                                id: "QyDR7p",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "State is required"
                                    }
                                ]
                            });
                        }
                        if (values.zipcode.length < 1) {
                            errors.zipcode = strictLocalize({
                                id: "S3dcLw",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Zipcode/Postal code is required"
                                    }
                                ]
                            });
                        }
                        if (!(Object.keys(errors).length === 0)) return [
                            3,
                            3
                        ];
                        if (!(values.phoneNumber.length > 8)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validatePhoneNumber([
                                IValidatePhoneNumberRequest.build({
                                    phone_number: values.phoneNumber,
                                    country: values.country
                                })
                            ])
                        ];
                    case 1:
                        is_valid = _state.sent().is_valid;
                        if (!is_valid) {
                            errors.phoneNumber = strictLocalize({
                                id: "fGaQyA",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Phone number is invalid"
                                    }
                                ]
                            });
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        errors.phoneNumber = strictLocalize({
                            id: "fGaQyA",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Phone number is invalid"
                                }
                            ]
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            errors
                        ];
                }
            });
        });
        return function validateForm(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        validateForm: validateForm
    };
};
